import { IRequirementRowPadding } from 'app/models/Placement/PlacementSummary';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useRequirementFilter } from '../../../Helpers/requirementFilter';
import {
  selectBookingInfo,
  selectEditableFields,
} from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { ConfirmationCheckbox } from '../../TableComponents/Confirmations/ConfirmationCheckbox';
import { ConfirmationsRow } from '../../TableComponents/Confirmations/ConfirmationsTable';

export const DirectDeposit = ({ hasRequirements }: IRequirementRowPadding) => {
  const { t } = useTranslation();
  const { directDeposit: initialValue } = useSelector(selectEditableFields);
  const {
    confirmation: { directDeposit },
    requirementFilter,
  } = useSelector(selectBookingInfo);
  const { control } = useFormContext();

  const { display } = useRequirementFilter('booking-confirmation', requirementFilter, directDeposit?.type);

  return display ? (
    <Controller
      control={control}
      name="directDeposit"
      render={({ field }) => (
        <ConfirmationsRow
          id="placement-booking-confirmation-direct-deposit"
          lastUpdatedBy={field?.value?.lastUpdatedBy}
          lastUpdatedDate={field?.value?.lastUpdatedAt}
          requirement={directDeposit?.type}
          hasOtherRequirements={hasRequirements}
          controlComponent={
            <ConfirmationCheckbox
              label={t('placement.profile.summary.booking.confirmations.directDeposit')}
              defaultState={initialValue}
              disabled
              {...field}
            />
          }
        />
      )}
    />
  ) : null;
};
